import { GraduationCap, Award, Calendar, Stethoscope, Star } from "lucide-react";

const DOCTORS = [
  {
    name: "Dr. Shabeer Ali",
    qualification: "BDS",
    role: "Chief Dental Surgeon",
    lead: true,
    image:
      "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Ashma Shabeer",
    qualification: "BDS",
    role: "Chief Dental Surgeon",
    lead: true,
    image:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Sabana Yasmin",
    qualification: "BDS",
    role: "General Dentist",
    image:
      "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Shajerin V Rafiq",
    qualification: "BDS, FAGE",
    role: "General Dentist",
    image:
      "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Firoz Moopen",
    qualification: "MDS",
    role: "Consultant Orthodontist & Dentofacial Orthopedist",
    image:
      "https://images.unsplash.com/photo-1651008376811-b90baee60c1f?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Jyothish",
    qualification: "MDS",
    role: "Consultant Oral & Maxillofacial Surgeon",
    image:
      "https://images.unsplash.com/photo-1584467735815-f778f274e296?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Ajesh",
    qualification: "MDS",
    role: "Consultant Periodontist",
    image:
      "https://images.unsplash.com/photo-1637059824899-a441006a6875?w=800&q=80&auto=format&fit=crop",
  },
  {
    name: "Dr. Denis Paul",
    qualification: "MDS",
    role: "Consultant Pedodontist",
    image:
      "https://images.unsplash.com/photo-1638202993928-7267aad84c31?w=800&q=80&auto=format&fit=crop",
  },
];

const DoctorPlaceholder = () => {
  return (
    <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-[#009688] via-[#00796B] to-[#004D40] flex flex-col items-center justify-center p-6 pb-16 group-hover:scale-105 transition-transform duration-700">
      <div className="relative w-20 h-20 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center mb-3 shadow-inner">
        <svg
          className="w-10 h-10 text-white/90"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Doctor Silhouette */}
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          {/* Stethoscope */}
          <path d="M19 12v1.5a3 3 0 0 1-6 0V12" />
          <circle cx="16" cy="18" r="1.5" />
          <path d="M16 13.5v3" />
        </svg>
      </div>
    </div>
  );
};

export const Doctors = () => {
  const goBook = () =>
    document.getElementById("appointment")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="doctors"
      data-testid="doctors-section"
      className="relative py-20 sm:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl reveal">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#009688]/10 text-[#009688] text-xs font-semibold tracking-wide uppercase">
            Meet Our Doctors
          </div>
          <h2 className="mt-5 text-4xl sm:text-5xl font-semibold tracking-tight text-[#1F2937] leading-[1.05]">
            Skilled hands. <span className="text-[#009688]">Kind hearts.</span>
          </h2>
          <p className="mt-5 text-lg text-[#1F2937]/65">
            Our full team of qualified specialists combines years of clinical
            experience with a compassionate, patient-first approach.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {DOCTORS.map((doc, i) => (
            <article
              key={doc.name}
              data-testid={`doctor-card-${i}`}
              className="reveal group relative rounded-3xl bg-gradient-to-br from-[#F7FAFC] to-white border border-[#009688]/10 overflow-hidden hover:border-[#009688]/40 hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(0,150,136,0.25)] transition-all duration-500"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <DoctorPlaceholder />
                {/*
                <img
                  src={doc.image}
                  alt={doc.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent pointer-events-none" />

                {doc.lead && (
                  <div className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/95 backdrop-blur-sm text-[#009688] text-[10.5px] font-bold uppercase tracking-wider">
                    <Star className="w-3 h-3 fill-current" />
                    Chief Surgeon
                  </div>
                )}

                <div className="absolute bottom-3 left-3 right-3">
                  <div className="text-white font-[Outfit] font-semibold text-lg leading-tight tracking-tight">
                    {doc.name}
                  </div>
                  <div className="text-white/80 text-xs mt-0.5 font-medium">
                    {doc.qualification}
                  </div>
                </div>
              </div>

              <div className="p-5">
                <div className="flex items-start gap-2 text-[13px] text-[#1F2937]/75 leading-snug min-h-[42px]">
                  <Stethoscope className="w-4 h-4 text-[#009688] shrink-0 mt-0.5" />
                  {doc.role}
                </div>

                <button
                  onClick={goBook}
                  data-testid={`doctor-book-btn-${i}`}
                  className="mt-4 w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-[#009688]/8 text-[#009688] text-[13px] font-semibold hover:bg-[#009688] hover:text-white active:scale-95 transition-all"
                >
                  <Calendar className="w-3.5 h-3.5" />
                  Book Consultation
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
